import { IconProps } from '../../Types';

export const IconTotalBooking = (props: IconProps) => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}
        >
            <path
                d='M7.74984 2.5C7.74984 2.08579 7.41406 1.75 6.99984 1.75C6.58563 1.75 6.24984 2.08579 6.24984 2.5V4.07926C4.81051 4.19451 3.86562 4.47737 3.17142 5.17157C2.47722 5.86577 2.19436 6.81067 2.0791 8.25H21.9206C21.8053 6.81067 21.5225 5.86577 20.8283 5.17157C20.1341 4.47737 19.1892 4.19451 17.7498 4.07926V2.5C17.7498 2.08579 17.4141 1.75 16.9998 1.75C16.5856 1.75 16.2498 2.08579 16.2498 2.5V4.0129C15.5846 4 14.8389 4 13.9998 4H9.99984C9.16081 4 8.41511 4 7.74984 4.0129V2.5Z'
                fill={props.color}
            />
            <path
                opacity='0.4'
                fillRule='evenodd'
                clipRule='evenodd'
                d='M2 12C2 11.161 2 10.4153 2.0129 9.75H21.9871C22 10.4153 22 11.161 22 12V14C22 17.7712 22 19.6569 20.8284 20.8284C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14V12ZM17 14C17.5523 14 18 13.5523 18 13C18 12.4477 17.5523 12 17 12C16.4477 12 16 12.4477 16 13C16 13.5523 16.4477 14 17 14ZM17 18C17.5523 18 18 17.5523 18 17C18 16.4477 17.5523 16 17 16C16.4477 16 16 16.4477 16 17C16 17.5523 16.4477 18 17 18ZM13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13ZM13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17ZM7 14C7.55228 14 8 13.5523 8 13C8 12.4477 7.55228 12 7 12C6.44772 12 6 12.4477 6 13C6 13.5523 6.44772 14 7 14ZM7 18C7.55228 18 8 17.5523 8 17C8 16.4477 7.55228 16 7 16C6.44772 16 6 16.4477 6 17C6 17.5523 6.44772 18 7 18Z'
                fill={props.color}
            />
        </svg>
    );
};

IconTotalBooking.defaultProps = {
    className: '',
    onClick: () => { },
    color: '#2970FF',
};
